<template>
  <div class="slider"
    @mousedown="sliderMove"
    :class="{ active: isActive }">
    <div class="thumb-container"
      :style="{ left: left + '%' }"
      @touchstart="onMouseDown"
      @mousedown="onMouseDown">
      <div class="thumb"></div>
    </div>
  </div>
</template>

<style lang="scss">
  .slider {
    width: 100%;
    height: 100%;
    position: relative;

    &.active .thumb-container {
      transition: none;
    }
  }

  .thumb-container {
    position: absolute;
    transition: 250ms linear;
    left: 0%;
    height: 100%;
  }

  .thumb {
    width: 10px;
    height: 100%;
    left: -5px;
    position: absolute;
    cursor: ew-resize;

    &:after {
      position: absolute;
      content: '';
      width: 2px;
      height: 100%;
      left: 4px;
      background: red;
    }
  }
</style>

<script>
function addOnceEventListener (el, event, cb) {
  var once = () => {
    cb()
    el.removeEventListener(event, once, false)
  }
  el.addEventListener(event, once, false)
}

export default {
  props: {
    value: { type: Number, default: 0 }
  },

  data () {
    return {
      app: {},
      isActive: false,
      left: 0
    }
  },

  watch: {
    value () {
      if (!this.isActive) {
        this.left = this.value
      }
    }
  },

  methods: {
    sliderMove (e) {
      if (!this.isActive) {
        this.onMouseMove(e)
      }
    },
    onMouseDown (e) {
      const options = { passive: true }
      this.isActive = true
      this.app.style.userSelect = 'none'

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options)
        addOnceEventListener(this.app, 'touchend', this.onMouseUp)
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options)
        addOnceEventListener(this.app, 'mouseup', this.onMouseUp)
      }
    },
    onMouseUp () {
      const options = { passive: true }
      this.isActive = false
      this.app.style.userSelect = 'auto'
      this.app.removeEventListener('touchmove', this.onMouseMove, options)
      this.app.removeEventListener('mousemove', this.onMouseMove, options)
    },
    onMouseMove (e) {
      const {
        left: offsetLeft,
        width: trackWidth
      } = this.slider.getBoundingClientRect()
      const clientX = 'touches' in e ? e.touches[0].clientX : e.clientX
      let left = (
        ((clientX - offsetLeft) / trackWidth) * 100
      )
      left = left < 0 ? 0 : left > 100 ? 100 : left
      this.left = left
      this.$emit('update', left)
    }
  },

  mounted () {
    // dragging is attached to root element so it isn't restricted only to slider area
    this.app = this.$root.$el
    this.slider = this.$el
    this.left = this.value
  }
}
</script>




// WEBPACK FOOTER //
// Slider.vue?1463497f